import * as React from 'react'
import { motion } from 'framer-motion'
import { Box, SxProps } from '@mui/material'
import { useAnimationStyles } from 'src/Libs/live-view'
import EnergyFlowIndicatorSvg from './EnergyFlowIndicatorSvg'

export interface ArrowSvgProps {
  transform: string
  direction?: 'in' | 'out'
  doRotateBy180Deg?: boolean
  sx?: SxProps
}

const SideArrowSvg: React.FC<ArrowSvgProps> = ({ direction, transform, doRotateBy180Deg = false, sx }) => {
  const { classes, cx } = useAnimationStyles({ direction })

  return (
    <Box sx={{ position: 'relative', transform, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="128" height="15" viewBox="0 0 128 15" fill="none">
        <g id="livevalue_arrows">
          <motion.g id="line">
            <motion.path id="Vector 8" d="M126.001 7.49841H64.501H2.00098" stroke="#A4AAAE" strokeWidth="2" strokeLinecap="round" />
          </motion.g>
          {direction === 'out' && (
            <g id="arrow_out_side_arrow">
              <path
                d="M120.709 14.7074L120.634 14.7758C120.241 15.0963 119.661 15.0736 119.295 14.7074C118.929 14.3412 118.906 13.7612 119.227 13.3685L119.295 13.2932L125.794 6.79458C126.184 6.40406 126.818 6.40406 127.208 6.79458C127.599 7.18511 127.599 7.81827 127.208 8.20879L120.709 14.7074Z"
                fill="#A4AAAE"
              />
              <path
                d="M119.294 1.7067L119.225 1.63074C118.905 1.23797 118.928 0.658537 119.294 0.292482C119.685 -0.0980416 120.318 -0.0980416 120.708 0.292482L127.208 6.79248C127.599 7.183 127.599 7.81617 127.208 8.20669C126.818 8.59721 126.185 8.59722 125.794 8.20669L119.294 1.7067Z"
                fill="#A4AAAE"
              />
            </g>
          )}
          {direction === 'in' && (
            <g id="arrow_in_side_arrow">
              <path
                d="M6.79177 0.2932L6.86704 0.224837C7.25982 -0.0956993 7.8398 -0.0729835 8.20599 0.2932C8.57217 0.659384 8.59488 1.23937 8.27435 1.63215L8.20599 1.70741L1.70737 8.20603C1.31685 8.59655 0.683681 8.59655 0.293156 8.20603C-0.0973676 7.8155 -0.0973676 7.18234 0.293156 6.79181L6.79177 0.2932Z"
                fill="#A4AAAE"
              />
              <path
                d="M8.20722 13.2939L8.27627 13.3699C8.59645 13.7626 8.57327 14.3421 8.20722 14.7081C7.81669 15.0987 7.18353 15.0987 6.793 14.7081L0.293007 8.20813C-0.0975174 7.81761 -0.0975183 7.18444 0.293006 6.79392C0.68353 6.40339 1.31669 6.40339 1.70722 6.79392L8.20722 13.2939Z"
                fill="#A4AAAE"
              />
            </g>
          )}
        </g>
      </svg>
      {!!direction && <Box className={cx(classes.directionIndicator, classes.sideArrowAnimation, classes.directionIndicatorHorizontal)} />}
      {!!direction && (
        <EnergyFlowIndicatorSvg
          className={cx(classes.directionIndicator, classes.sideArrowAnimation, classes.directionIndicatorHorizontal)}
          doRotateBy180Deg={doRotateBy180Deg}
          direction={direction}
        />
      )}
    </Box>
  )
}

export default SideArrowSvg
